module.exports = __webpack_public_path__ + "img/logo.1484aa61.png";